// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close-icon[data-v-0d64047c]{position:absolute!important;cursor:pointer;top:12px;right:12px}.headline-large[data-v-0d64047c]{font-size:2.25rem!important;font-weight:500!important;letter-spacing:0!important;line-height:1.22!important}.body-large-text[data-v-0d64047c]{font-size:1.125rem!important;font-weight:400!important;letter-spacing:1px!important;line-height:1.5!important}.referral-dialog a[data-v-0d64047c]{color:#268aef}", ""]);
// Exports
module.exports = exports;
